<template>
  <a :href="props.card.link" class="icon-card flex p-3 px-4 md:px-3 gap-4 overflow-hidden rounded-lg hover:bg-gray-50 cursor-pointer">
    <div class="w-6 h-6">
      <div class="font-a-icon">
        <i :class="'fa-regular fa-' + props.card.icon" class="text-base sm:text-xl text-primary-600"></i>
      </div>
    </div>
    <div>
      <div class="text-base font-semibold pb-1 leading-6 text-gray-900"><p v-html="replaceWithBr(props.card.label)"></p></div>
      <div v-if="props.card.text !== ''" class="text-sm font-normal leading-5 text-gray-600 line-clamp-2"><p v-html="replaceWithBr(props.card.text)"></p></div>
    </div>
  </a>
</template>

<script setup>
import { useHeaderStore } from '@/stores'

const headerStore = useHeaderStore()

const props = defineProps(['card'])

function replaceWithBr(text) {
  return text.replace(/\n/g, "<br />")
}

</script>